import * as Yup from "yup";
import dayjs from "dayjs";
export const initialValues = {
  campaignOwner: "",
  campaignName: "",
  startdate: null,
  enddate: null,
  status: "",
  expectedRevenue: "",
  expectedResponse: "",
  budgetCost: "",
  actualCost: "",
  description: "",
  type: "",
};

export const validationSchema = (isEditMode: boolean) =>
  Yup.object()
    .shape({
      campaignName: Yup.string().required("Campaign Name cannot be empty"),
      type: Yup.string().required("Type cannot be empty"),
      description: Yup.string()
        .max(150, "Description cannot be more than 150 characters")
        .nullable(),

      startdate: Yup.mixed<dayjs.Dayjs>()
        .nullable()
        .test("startdate-valid", "Please enter valid date", (value) => {
          return (
            value === null ||
            (dayjs(value).isValid() && !dayjs(value).isBefore(dayjs("1900-01-01")))
          );
        })
        .test("startdate-before-enddate", "Start date cannot be after end date", function (value) {
          const { enddate } = this.parent as any;
          if (value && enddate && value.isAfter(dayjs(enddate))) {
            return this.createError({
              path: "startdate",
              message: "Start date cannot be after end date",
            });
          }
          return true;
        }),

      enddate: Yup.mixed<dayjs.Dayjs>()
        .nullable()
        .test("enddate-valid", "Please enter valid date", (value) => {
          return (
            value === null ||
            (dayjs(value).isValid() && !dayjs(value).isBefore(dayjs("1900-01-01")))
          );
        })
        .test("enddate-after-startdate", "End date cannot be before start date", function (value) {
          const { startdate } = this.parent as any;
          if (value && startdate && value.isBefore(dayjs(startdate))) {
            return this.createError({
              path: "enddate",
              message: "End date cannot be before start date",
            });
          }
          return true;
        }),
    })
    .test(
      "dates-required",
      "Please enter both startdate and enddate",
      function (values) {
        const { startdate, enddate } = values as any;
        if ((startdate && !enddate) || (!startdate && enddate)) {
          return this.createError({
            path: !startdate ? "startdate" : "enddate",
            message: `Please enter the ${!startdate ? "Start Date" : "End Date"}`,
          });
        }
        return true;
      }
    );